import { SET_ALL_LEAVES, SET_LEAVE_PAGE, SET_LEAVE_PAGE_SIZE, SET_LEAVE_TOTAL } from "../types"

const initialState = {
    leaves: [],
    page: 1,
    pageSize: 5,
    total: 0,
}

const myLeaveReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_ALL_LEAVES:
            return { ...state, leaves: action.payload }
        case SET_LEAVE_PAGE:
            return { ...state, page: action.payload }
        case SET_LEAVE_PAGE_SIZE:
            return { ...state, pageSize: action.payload }
        case SET_LEAVE_TOTAL:
            return { ...state, total: action.payload }
        default:
            return state
    }
}

export default myLeaveReducer
